import tIcon from '../../../assets/icon/ic-t.svg';
import lineIcon from '../../../assets/icon/grip-lines.svg';
import squareIcon from '../../../assets/icon/square-line-icon.svg';
import circleIcon from '../../../assets/icon/circle-line-icon.svg';
import imageIcon from '../../../assets/icon/image-icon.svg';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const DraggableItem = ({
    item,
    index,
    selectedShape,
    setSelectedShape,
    setShowResources,
    updateForm,
    provided,
    snapshot,
    icons,
    handleDeleteShape,
    procesName,
    t,
}) => {
    const templateIcons = {
        textTemplate: { src: tIcon, alt: 'textTemplate' },
        lineTemplate: { src: lineIcon, alt: 'lineTemplate' },
        rectangleTemplate: { src: squareIcon, alt: 'rectangleTemplate' },
        ellipseTemplate: { src: circleIcon, alt: 'ellipseTemplate' },
        imageTemplate: { src: imageIcon, alt: 'imageTemplate' },
    };
    const isSelected = selectedShape?.id === item?.id;
    const isDragging = snapshot.isDragging;

    return (
        <div
            className={` d-flex justify-content-between with-margin ${
                isSelected ? 'activeShape selectedShape' : ''
            }`}
            onClick={() => {
                setSelectedShape(item);
                setShowResources(false);
            }}
            ref={provided.innerRef}
            {...provided.dragHandleProps}
            {...provided.draggableProps}
        >
            <div
                className='draggable-item-content w-100 d-flex align-items-center'
                onClick={() => {
                    setSelectedShape(item);
                    updateForm(item);
                    setShowResources(false);
                }}
            >
                {templateIcons[item.type] && (
                    <img
                        className='card-designer-image'
                        src={templateIcons[item.type].src}
                        alt={templateIcons[item.type].alt}
                    />
                )}

                <p className={`layer-text ${isDragging ? 'dragging' : ''}`}>
                    {item.type === 'imageTemplate' && !item.image
                        ? t('image_card_undefined')
                        : procesName(item.textName) + ' ' + (index + 1)}
                </p>
            </div>

            <button
                className='btn h-100 rounded-0 btn-delete-accordion'
                onClick={() => handleDeleteShape(item.id, item.property)}
            >
                <i className='fa fa-trash-o fs-4' aria-hidden='true'></i>
            </button>
        </div>
    );
};

export default DraggableItem;
